export default {
  "app-footer": () => import("/home/forge/career.proxify.io/releases/20250506142319/layouts/AppFooter/AppFooter.vue"),
  "app-header": () => import("/home/forge/career.proxify.io/releases/20250506142319/layouts/AppHeader/AppHeader.vue"),
  newsletter: () => import("/home/forge/career.proxify.io/releases/20250506142319/layouts/Newsletter/Newsletter.vue"),
  default: () => import("/home/forge/career.proxify.io/releases/20250506142319/layouts/default.vue")
}